(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-assets-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".products-solutions");
  const prevBtn = document.querySelector(".slider-btn.prev");
  const nextBtn = document.querySelector(".slider-btn.next");
  const progressFill = document.querySelector(".slider-progress-fill");
  const cards = slider.querySelectorAll(".product-card");

  function getCardWidth() {
    if (!cards.length) return 0;
    const style = window.getComputedStyle(cards[0]);
    const gap = parseInt(style.marginRight || 20);
    return cards[0].offsetWidth + gap;
  }

  function updateButtons() {
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    prevBtn.disabled = slider.scrollLeft <= 0;
    nextBtn.disabled = slider.scrollLeft >= maxScroll - 5;
  }

  function updateProgressBar() {
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const progress = (slider.scrollLeft / maxScroll) * 100;
    progressFill.style.width = `${Math.min(progress, 100)}%`;
  }

  prevBtn?.addEventListener("click", () => {
    const cardWidth = getCardWidth();
    slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
  });

  nextBtn?.addEventListener("click", () => {
    const cardWidth = getCardWidth();
    slider.scrollBy({ left: cardWidth, behavior: "smooth" });
  });

  slider.addEventListener("scroll", () => {
    updateButtons();
    updateProgressBar();
  });

  window.addEventListener("resize", () => {
    updateButtons();
    updateProgressBar();
  });

  // Initialize
  updateButtons();
  updateProgressBar();
});

  } catch(e) { console.error(e); }
})();
})();
